import React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default class FormItem extends React.Component
{
    render()
    {
        return (
            <div className={this.props.className ? this.props.className : "lmsformitem"}>
                {this.props.type === "checkbox" ? (
                    <label className="lmsformlabel"><span></span></label>   
                ) : (
                    <label className="lmsformlabel">{this.props.label}</label> 
                )}      
                <div className="lmsforminputcontainer">
                    { this.props.type === "phone" ? (
                        <ReactPhoneInput defaultCountry={'us'} name={this.props.name} 
                            onChange={(e) => this.props.inputChanged(e)} value={this.props.value} />
                    ) : this.props.type === "select" ? (
                        <select name="state" id="state" className="lmsforminput" 
                            onChange={(e) => this.props.inputChanged(e)} value={this.props.value}>
                            {this.props.defaultOption}
                            {this.props.options}
                        </select>
                    ) : this.props.type === "checkbox" ? (
                        <div className="lmscheckbox">
                            <input type="checkbox" name={this.props.name} id={this.props.name} className="lmscheckbox"
                                checked={this.props.checked} onChange={(e) => {this.props.inputChanged(e)} } />
                            {this.props.label}
                        </div>
                    ) : this.props.type === "textarea" ? (
                        <textarea name={this.props.name} id={this.props.name} className="lmstextarea"
                            value={this.props.value} onChange={(e) => {this.props.inputChanged(e) } }></textarea>
                    ) : this.props.type === "datetimestart" ? (
                        <DatePicker showTimeSelect name={this.props.name} id={this.props.name}
                            className="lmsforminput"
                            timeFormat="HH:mm" dateFormat="MM/DD/YYYY HH:mm"
                            selectsStart
                            timeIntervals={15}
                            selected={this.props.startDate} 
                            startDate={this.props.startDate} 
                            endDate={this.props.endDate}
                            onChange={this.props.inputChanged} />
                    ) : this.props.type === "datetimeend" ? (
                        <DatePicker showTimeSelect name={this.props.name} id={this.props.name}
                            className="lmsforminput"
                            timeFormat="HH:mm" dateFormat="MM/DD/YYYY HH:mm"
                            selectsEnd
                            timeIntervals={15}
                            selected={this.props.endDate} 
                            startDate={this.props.startDate} 
                            endDate={this.props.endDate}
                            onChange={this.props.inputChanged} />
                    ) : this.props.type === "radiobuttons" ? (
                        <div className="lmsradiobuttons">
                            {this.props.options.map((o) =>
                                <div key={o.value}>
                                    <input type="radio" name={this.props.name} id={this.props.name}
                                        value={o.value} checked={this.props.value == o.value}
                                        onChange={this.props.inputChanged} /> {o.name}
                                </div>
                            )}
                        </div>
                    ) : (
                        <input type={this.props.type} name={this.props.name} id={this.props.name} className="lmsforminput"
                            value={this.props.value} onChange={this.props.inputChanged} />
                    )}
                    { this.props.validationErrors ? (
                        <div className={this.props.validationErrors.map((e) => 
                        e.element).indexOf(this.props.name) === -1 ? "lmsformrequired" : "lmsformrequired lmsvalidationerror"
                        }>*</div>
                    ) : null}        
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/general/formitem.js